import React from 'react';
import CKEditor from 'react-ckeditor-component';

class RichTextEditor extends React.Component {

    constructor(props) {
		super(props);

		this.state = {
			value: props.value
		};
	}

    // Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
	}

	select = () => {
	}

	flag = (status) => {
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
    }
    
    // Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

    // Private
    _handleChange = (evt) => {
		const newContent = evt.editor.getData();
        this._update(newContent, newContent);
        this.onDirt();
    }

    _update = (value, parsed, formatted) => {
		this.setState({ value: value, display: formatted }, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);
			const status = requiredPassed && validationPassed;

			// Show error status if neccesary
			this.flag(status);
			this.onChange(value);

			// If managed by forms, trigger field change
			if (this.props.managed)
				this.props.onFieldChange(value, this.props.name);
		});
	}

    // React
    render() {
        let opts = {
            name: this.props.name,
            content: this.state.value,
            config: {
              scayt_uiTabs: '0,0,0',
			  removePlugins: "wsc, scayt",
			  autoParagraph:false,
			  readOnly: !this.props.enabled,
              removeButtons:'Table,Image,Anchor,About,Outdent,Indent,Blockquote'	//Source,
            },
            events: {
                "change": this._handleChange
			},
			scriptUrl: '/js/ckeditor/ckeditor.js'
        };

        return (<React.Fragment>
            <CKEditor {...opts}
                activeClass="p10"
            />
        </React.Fragment>);
    }
}

export default RichTextEditor;

RichTextEditor.defaultProps = {
	formControl: true,
	managed: false
};




// WEBPACK FOOTER //
// ./src/fw/forms/controls/richTextEditor/RichTextEditor.js